import {
  Box,
  Button,
  Card,
  Flex,
  Stack,
  Text,
  Toggle,
} from '@alexpireddu/map-ui';
import styled from '@emotion/styled';
import _ from 'lodash';
import { FC, useRef, ChangeEvent, useCallback } from 'react';
import { Col, Container, Row } from 'react-grid-system';
import { uploadCityLogoV1 } from '../../../apis';
import { uploadCityRulesV1 } from '../../../apis/cityApis';
import { CityLogo } from '../../../components';
import { useAppSelector } from '../../../hooks';
import { colors } from '../../../theming/theme';

const SameSizeButton = styled(Button)({
  width: '210px',
});

const Overview: FC = () => {
  const inputLogoRef = useRef<HTMLInputElement>(null);
  const inputRulesRef = useRef<HTMLInputElement>(null);
  const { city } = useAppSelector((store) => ({
    city: store.cityDetail,
  }));

  const handleClickUploadLogo = useCallback(() => {
    inputLogoRef?.current?.click();
  }, []);

  const handleChangeLogoUploaded = useCallback(
    (evt: ChangeEvent<HTMLInputElement>) => {
      if (_.some(evt.target.files)) {
        const file = _.head(evt.target.files);
        const formData = new FormData();
        formData.append('file', file as any);

        uploadCityLogoV1(city?.id!, formData);
      }
    },
    [city?.id]
  );

  const handleClickUploadRules = () => {
    inputRulesRef?.current?.click();
  };

  const handleChangeRulesUploaded = useCallback(
    (evt: ChangeEvent<HTMLInputElement>) => {
      if (_.some(evt.target.files)) {
        const file = _.head(evt.target.files);
        const formData = new FormData();
        formData.append('file', file as any);

        uploadCityRulesV1(city?.id!, formData);
      }
    },
    [city?.id]
  );

  return (
    <Container fluid>
      <Row>
        <Col xs={12} sm={12} md={12} lg={12} xl={12}>
          <Box ml={12} mt={12} mb={24}>
            <Text as="h2">Generalità comune</Text>
          </Box>
        </Col>
      </Row>
      <Row>
        <Col xs={12} sm={12} md={12} lg={12} xl={12}>
          <Box mb={24}>
            <Card size="xl">
              <Text as="h3" marginBottom="24px">
                Comune di
              </Text>
              <Stack direction="row" spacing={2} alignItems="center">
                <CityLogo cityId={city?.id!} />
                <Stack>
                  <Text as="h3" marginBottom="0" lineHeight={'2rem'}>
                    {city?.name}
                  </Text>
                  <Text as="p">Provincia: {city?.province.name}</Text>
                </Stack>
              </Stack>
              <Box mt="32px">
                <Flex alignItems="center">
                  <Box mr="12px">
                    <Text as="span" fontWeight="600">
                      Sottoscrizione
                    </Text>
                  </Box>
                  <Box mr="12px" display="flex" alignItems="center">
                    <Toggle
                      checked={city?.subscription === 2}
                      onChange={() => {}}
                      disabled={true}
                    />
                  </Box>
                  <Box>
                    <Text
                      as="span"
                      color={
                        city?.subscription === 2
                          ? colors.interaction300
                          : 'textMuted'
                      }
                    >
                      {city?.subscription === 2 ? 'Pubblica' : 'Privata'}
                    </Text>
                  </Box>
                </Flex>
              </Box>
              <Flex justifyContent={'flex-end'} mt="80px">
                <Box mr={'24px'}>
                  <SameSizeButton
                    variant="secondary"
                    onClick={handleClickUploadLogo}
                  >
                    Carica Logo
                  </SameSizeButton>
                  <input
                    type={'file'}
                    style={{ display: 'none' }}
                    ref={inputLogoRef}
                    onChange={handleChangeLogoUploaded}
                  />
                </Box>
                <Box>
                  <SameSizeButton
                    variant="secondary"
                    onClick={handleClickUploadRules}
                  >
                    Carica Regolamento
                  </SameSizeButton>
                  <input
                    type={'file'}
                    style={{ display: 'none' }}
                    ref={inputRulesRef}
                    onChange={handleChangeRulesUploaded}
                  />
                </Box>
              </Flex>
            </Card>
          </Box>
        </Col>
      </Row>
    </Container>
  );
};

export default Overview;
